import { Badge } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	AntdButton,
	ButtonContainer,
	ChildrenContainer,
	DetailPanel,
	Inner,
	PageHeader,
	PageSub,
	PageTitle,
	Section,
	Shell,
	Sidebar,
	SidebarBadge,
	SidebarIcon,
	SidebarItem,
	SidebarLabel,
	SidebarSectionLabel,
} from "./styles";
import Main from "../../../layout/main/Main";
import { useFilter } from "../../../../contexts/filterContext";
import { CONSTANTS } from "../../../../utils/constants";
import ModuleOneTransfer from "./components/module-one-transfer/ModuleOneTransfer";
import ModuleMarketplace from "./components/module-marketplace/ModuleMarketplace";
import { useAuth } from "../../../../contexts/authContext";
import { DatabaseOutlined, ShopOutlined } from "@ant-design/icons";
import { MdBusinessCenter } from "react-icons/md";
import { GiArtificialIntelligence } from "react-icons/gi";
import { MdFormatListBulleted, MdOutlineMonetizationOn } from "react-icons/md";

export default function MarketGeneralConfig({ userdata }) {
	const {
		generalConfigOT,
		setGeneralConfigOT,
		userRol,
		oneTransferSection,
		setOneTransferSection,
		marketplaceSection,
		setMarketplaceSection,
	} = useFilter();
	const { toValidateQty, agentOrdersQty } = useAuth();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Main>
			<Main.Header style={{ padding: "0 82px" }}>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Configuración General
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Inner>
				<PageHeader>
					<Section>
						<PageTitle>Configuración General</PageTitle>
						<PageSub>Administrá los parámetros del sistema</PageSub>
					</Section>

					<ButtonContainer>
						{((userdata.p_client && userdata.p_users) ||
							(userdata.p_client && !userdata.p_users)) && (
							<Badge
								count={agentOrdersQty}
								offset={[-2, 4]}
								size="small"
								color="#E24B4A"
							>
								<AntdButton
									onClick={() =>
										setGeneralConfigOT(CONSTANTS.MODULE_ONE_TRANSFER)
									}
									$active={generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER}
								>
									One Transfer
								</AntdButton>
							</Badge>
						)}

						<AntdButton
							onClick={() => setGeneralConfigOT(CONSTANTS.MODULE_MARKETPLACE)}
							$active={generalConfigOT === CONSTANTS.MODULE_MARKETPLACE}
						>
							Marketplace
						</AntdButton>
					</ButtonContainer>
				</PageHeader>

				<Shell>
					<Sidebar>
						<SidebarSectionLabel>
							{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER
								? "One Transfer"
								: "Marketplace"}
						</SidebarSectionLabel>

						{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER ? (
							<>
								<SidebarItem
									$active={oneTransferSection === "general"}
									onClick={() => setOneTransferSection("general")}
								>
									<SidebarIcon $active={oneTransferSection === "general"}>
										<DatabaseOutlined />
									</SidebarIcon>
									<SidebarLabel>Configuración General</SidebarLabel>
								</SidebarItem>

								{userdata.p_client && userdata.p_users && (
									<SidebarItem
										$active={oneTransferSection === "business"}
										onClick={() => setOneTransferSection("business")}
									>
										<SidebarIcon $active={oneTransferSection === "business"}>
											<MdBusinessCenter size={16} />
										</SidebarIcon>
										<SidebarLabel>Negocio</SidebarLabel>
									</SidebarItem>
								)}

								{userdata.p_client && userdata.p_users && (
									<SidebarItem
										$active={oneTransferSection === "ia"}
										onClick={() => setOneTransferSection("ia")}
									>
										<SidebarIcon $active={oneTransferSection === "ia"}>
											<GiArtificialIntelligence size={16} />
										</SidebarIcon>
										<SidebarLabel>IA</SidebarLabel>
										{agentOrdersQty > 0 && (
											<SidebarBadge>{agentOrdersQty}</SidebarBadge>
										)}
									</SidebarItem>
								)}
							</>
						) : (
							<>
								<SidebarItem
									$active={marketplaceSection === "general"}
									onClick={() => setMarketplaceSection("general")}
								>
									<SidebarIcon $active={marketplaceSection === "general"}>
										<ShopOutlined />
									</SidebarIcon>
									<SidebarLabel>Configuración General</SidebarLabel>
								</SidebarItem>

								<SidebarItem
									$active={marketplaceSection === "products"}
									onClick={() => setMarketplaceSection("products")}
								>
									<SidebarIcon $active={marketplaceSection === "products"}>
										<MdFormatListBulleted size={16} />
									</SidebarIcon>
									<SidebarLabel>Gestión de Productos</SidebarLabel>
								</SidebarItem>

								<SidebarItem
									$active={marketplaceSection === "publicity"}
									onClick={() => setMarketplaceSection("publicity")}
								>
									<SidebarIcon $active={marketplaceSection === "publicity"}>
										<MdOutlineMonetizationOn size={16} />
									</SidebarIcon>
									<SidebarLabel>Publicidad</SidebarLabel>
								</SidebarItem>
							</>
						)}
					</Sidebar>

					<DetailPanel>
						<ChildrenContainer>
							{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER &&
								((userdata.p_client && userdata.p_users) ||
									(userdata.p_client && !userdata.p_users)) && (
									<ModuleOneTransfer
										userdata={userdata}
										agentOrdersQty={agentOrdersQty}
										activeSection={oneTransferSection}
									/>
								)}

							{generalConfigOT === CONSTANTS.MODULE_MARKETPLACE && (
								<ModuleMarketplace
									userdata={userdata}
									userRol={userRol}
									activeSection={marketplaceSection}
								/>
							)}
						</ChildrenContainer>
					</DetailPanel>
				</Shell>
			</Inner>
		</Main>
	);
}
